import { render, staticRenderFns } from "./previewDomainSetting.vue?vue&type=template&id=033ec96f&scoped=true"
import script from "./previewDomainSetting.vue?vue&type=script&lang=js"
export * from "./previewDomainSetting.vue?vue&type=script&lang=js"
import style0 from "./previewDomainSetting.vue?vue&type=style&index=0&id=033ec96f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033ec96f",
  null
  
)

export default component.exports